import React from 'react';

function Settings(props){
    return(
        <>
            <div className="">
                <img className="" src={props.settingImg} alt={props.settingName}/>
            </div>
        </>
    )
}
export default Settings